











import { BButton } from "bootstrap-vue";
import axios from "@/libs/axios";
import { useToast } from "vue-toastification/composition";
import i18n from "@/libs/i18n";
import useContactsLists from "@/composables/useContactsLists";
import toastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import { computed, onMounted } from "@vue/composition-api";

export default {
    components: {
        BButton,
    },
    props: {
        undeliveredEngageContactIds: {
            type: Array,
            required: true,
        },
        contacts: {
            type: Array,
            required: true,
        },
        contactListId: {
            type: Number,
            required: true,
        },
    },
    setup(props, { root }) {
        const toast = useToast();
        const { contactsList, fetchContactsList } = useContactsLists();

        onMounted(() => {
            fetchContactsList(props.contactListId);
        });

        const contactsListIds = computed(() => {
            if (!contactsList.value) {
                return [];
            }
            return contactsList.value.contacts.map((contact) => contact.id);
        });

        const removeUndeliveredFromList = () => {
            root.$bvModal
                .msgBoxConfirm(i18n.t("engage.overview.remove-undelivered-confirm"), {
                    title: i18n.t("engage.overview.remove-undelivered-confirm-title", {
                        listName: contactsList.value.name,
                    }),
                    cancelTitle: i18n.t("confirm.Cancel"),
                    cancelVariant: "light",
                    okTitle: i18n.t("confirm.Yes, delete"),
                    hideHeaderClose: false,
                    headerCloseVariant: "light",
                    centered: true,
                })
                .then((result) => {
                    if (result) {
                        const nmbrOfUndeliveredContacts = props.undeliveredEngageContactIds.length;
                        const deliveredEngageContacts = props.contacts
                            .filter(
                                (contact) =>
                                    !props.undeliveredEngageContactIds.includes(contact.contactId) &&
                                    contactsListIds.value.includes(contact.contactId)
                            )
                            .map((contact) => {
                                return { id: contact.contactId, name: contact.name };
                            });

                        const contactListRequestObject = {
                            id: props.contactListId,
                            contacts: deliveredEngageContacts,
                            description: contactsList.value.description,
                            name: contactsList.value.name,
                        };

                        axios
                            .patch(`/contacts-lists/${contactListRequestObject.id}`, contactListRequestObject)
                            .then((result) => {
                                contactsList.value = result.data;

                                toast({
                                    component: toastificationContent,
                                    props: {
                                        title: i18n.t("toast.update.title"),
                                        text: i18n.tc(
                                            "engage.overview.remove-undelivered-success",
                                            nmbrOfUndeliveredContacts,
                                            {
                                                amount: nmbrOfUndeliveredContacts,
                                                listName: contactsList.value.name,
                                            }
                                        ),
                                        icon: "check",
                                        variant: "success",
                                    },
                                });
                            });
                    }
                });
        };

        return {
            removeUndeliveredFromList,
        };
    },
};
